import { render, staticRenderFns } from "./NotesListing.vue?vue&type=template&id=4774db70&"
import script from "./NotesListing.vue?vue&type=script&lang=js&"
export * from "./NotesListing.vue?vue&type=script&lang=js&"
import style0 from "./NotesListing.vue?vue&type=style&index=0&id=4774db70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports